import React from "react";
import { TemplateWrapped } from "../../Layout";
import { Button } from "../../ui/button";
import { useAllTransactionsDiva } from "../AllTransactionsDiva/hooks/useAllTransactionsDiva";
import { ConnectionsMainContent } from "../ConnectionsDiva/components";
import moment from "moment";
import Dashboard from "../Dashboard";

const DashboardDiva = ({ permissions }) => {
  const {
    practiceSelectedLabel,
    clientSelected,
    togglePracticeModal,
    practicesSelected,
  } = useAllTransactionsDiva(permissions);

  return (
    <TemplateWrapped
      title="Insurance Verification | All Transactions"
      showTitle={false}
    >
      {practicesSelected.length === 0 && (
        <main className="flex-1 overflow-auto p-6 mt-5">
          <div
            className="alert alert-alt alert-warning"
            role="alert"
            style={{
              padding: "20px 12px",
              fontSize: "14px",
              borderLeft: "3px solid",
            }}
          >
            Dear user, once you select a connection, the corresponding data will
            be displayed
          </div>
          <ConnectionsMainContent />
        </main>
      )}
      {practicesSelected.length > 0 && (
        <div
          className="panel"
          style={{ backgroundColor: "transparent", boxShadow: "none" }}
        >
          <div className="panel-body">
            <main className="flex-1 overflow-auto p-6">
              {/* Page Header */}
              <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                  Dashboard
                </h1>
                <p className="text-gray-500">
                  Quick overview of current connections and verification
                  activity
                </p>
              </div>

              <div className="flex items-center justify-between mb-6 pb-3 border-b border-gray-300">
                <div className="flex items-center space-x-4">
                  <span className="text-md  text-gray-600">
                    {clientSelected?.client[0]?.name || "Not found client"} -{" "}
                    {practiceSelectedLabel} <span className="text-lg">•</span>{" "}
                    {moment().format("MM/DD/YYYY")}
                  </span>
                </div>
                <Button
                  className={`!bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9`}
                  onClick={() => togglePracticeModal()}
                >
                  Show
                </Button>
              </div>
              <Dashboard hideWrapped={true} />
              {/* <div className="space-y-6 mt-2">
                 Header
                <h4 className="text-lg font-medium text-gray-700">
                  Metrics Overview
                </h4>

                 Metrics Cards
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                   Verified Today
                  <CardMetric
                    label="Verified Today"
                    showMetricsPercentage={true}
                    countMetric={38}
                    icon={<CheckCircle className="h-5 w-5 text-green-600" />}
                    metricPercentage="+5% since yesterday"
                    metricPercentageColor="text-green-600"
                    metricPercentageBg="#eefaf0"
                    iconBg="bg-green-100"
                  />

                   Pending
                  <CardMetric
                    label="Pending"
                    showMetricsPercentage={false}
                    countMetric={12}
                    icon={<Clock className="h-5 w-5 text-blue-600" />}
                    iconBg="bg-blue-100"
                  />

                   Failed Checks
                  <CardMetric
                    label="Failed Checks"
                    showMetricsPercentage={true}
                    countMetric={4}
                    icon={<AlertTriangle className="h-5 w-5 text-orange-600" />}
                    metricPercentage="-2 from yesterday"
                    metricPercentageColor="text-red-500"
                    metricPercentageBg="#faf0f0"
                    iconBg="bg-orange-100"
                  />

                   Most Active Practice
                  <CardMetric
                    label="Most Active Practice"
                    showMetricsPercentage={false}
                    countMetric="Coral Gables"
                    icon={<MapPin className="h-5 w-5 text-purple-600" />}
                    iconBg="bg-purple-100"
                  />
                </div>

                 Bottom Section
                <BottomSection />
              </div>*/}
            </main>
          </div>
        </div>
      )}
    </TemplateWrapped>
  );
};

export default DashboardDiva;
